export function groupBy<T>(array: T[], getKey: (item: T) => string): { [key: string]: T[] } {
  const map: { [key: string]: T[] } = {}

  array.forEach((item) => {
    const key = getKey(item)
    const collection = map[key]
    if (!collection) {
      map[key] = [item]
    } else {
      collection.push(item)
    }
  })
  return map
}
